<template>
  <div class="container">
    <!-- Your template code here -->
    <!-- 面包屑 -->
    <div>
      <div class="breadcrumb">
        <!-- <span class="breadcrumbText">当前位置：首页 > </span>
        <span v-if="typeof labelName ==='object'">
          <a class="hoverClass" @click="backFirstHandle">{{ labelName.firstLabelName }}</a>
          <span> > </span>
          <a class="hoverClass" @click="backHandle">{{ labelName.labelName }}</a>
        </span> -->
        <a class="backBtn" @click="backHandle"><a-icon type="left" />返回</a>
      </div>
      <!-- <template>
        <div v-for="matter in matterList" :key="matter.iid" class="matterNameClass" @click="toOneThingGuide(matter.iid, matter.itemName, matter)">
          <a-icon :component="point" style="margin-right: 16px;" :style="{ fontSize: '3px'}" />
          <a class="hoverClass">{{ matter.itemName }}</a>
        </div>
      </template> -->
    </div>

    <div class="tag-box">
      <h1 class="level1-tagname">{{ serviceData.labelName }}</h1>

      <div class="tag-card-box" v-if="serviceData.relatedItemList && serviceData.relatedItemList.length > 0">
        <div class="tag-card" v-for="levelTwoItem in serviceData.relatedItemList" :key="levelTwoItem.iid" @click="toOneThingGuide(levelTwoItem.iid, levelTwoItem.itemName, levelTwoItem)">
          <div class="service-box">
            <div class="service-item">
              <p>{{ levelTwoItem.itemName }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="tag-box level2-tagbox" v-if="serviceData.children && serviceData.children.length > 0" v-for="levelThreeLabel in serviceData.children" :key="levelThreeLabel.labelId">
        <h1 class="level2-tagname">{{ levelThreeLabel.labelName }}</h1>

        <div class="tag-card-box" v-if="serviceData.relatedItemList && serviceData.relatedItemList.length > 0">
          <div class="tag-card" v-for="levelThreeItem in levelThreeLabel.relatedItemList" :key="levelThreeItem.iid" @click="toOneThingGuide(levelThreeItem.iid, levelThreeItem.itemName, levelThreeItem)">
            <div class="service-box">
              <div class="service-item">
                <p>{{ levelThreeItem.itemName }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { jiopWebAPI } from '@/api/jiopweb/jiopweb'

export default {
  name: 'HotServicesLevel2Page',
  // Your script code here
  data () {
    return {
      // Your data properties here
      levelTwoTag: '',
      levelThreeTag: '',
      params: {
        pageNo: 1,
        pageSize: 20,
        districtId: sessionStorage.getItem('districtId'),
        labelId: ''
      },
      labelName: '',
      serviceData: {}
    }
  },
  methods: {
    init (labelId, labelName, serviceData) {
      this.serviceData = serviceData
      // this.$set(this.serviceData, 'levelTwoService', serviceData)
      console.log(this.serviceData, 'serviceData')
      if (labelId) {
        this.labelName = labelName
        this.params.labelId = labelId
      }
      // this.levelTwoTag = serviceData.relatedItemList[0]?.iid
      jiopWebAPI.matterList(this.params).then(res => {
        this.totalCount = res.data.list.length
        this.matterList = res.data.list.filter((v, index) => {
          return (this.params.pageNo - 1) * 10 <= index && index < 10 * this.params.pageNo
        })
      })
    },

    backHandle () {
      this.params.pageNo = 1
      this.$emit('backLabel', this.params.labelId)
    },

    backFirstHandle () {
      this.params.pageNo = 1
      this.$emit('backFirstHandle', this.params.labelId)
    },

    toOneThingGuide (value, name, itt) {
      sessionStorage.setItem('matter_name', itt.oneThingName)
      this.levelTwoTag = value
      const url = this.$router.resolve({ path: '/guideSimple', query: { itemId: value, bannerType: this.$route.query.bannerType } })
      window.open(url.href, '_blank')
    }
  }
}
</script>

<style lang="less" scoped>
/* Your styles here */
.container {
  margin: 0 auto;
  max-width: 1200px;

  .breadcrumb {
    padding-top: 14px;
    .breadcrumbText {

      font-size: 14px;
      color: #999999;
      letter-spacing: 0;
      font-weight: 400;
    }
    .backBtn {
      font-size: 16px;
    }
  }
  .matterNameClass {
    font-size: 16px;
    color: #333333;
    line-height: 28px;
    font-weight: 400;
    display: flex;
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px solid #D7D8D9;
  }

  .tag-box {
    .level1-tagname {
      font-size: 30px;
      color: #333;
      margin-top: 10px;
    }
    .level2-tagname {
      font-size: 24px;
      color: #333;
      margin-top: 10px;
    }

    .tag-card-box {
      display: flex;
      flex-wrap: wrap;
      // justify-content: space-between;
      margin-top: 20px;
      // 为子元素中间添加间距
      gap: 2%;

      .tag-card {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        padding: 20px;
        box-shadow: 0 0 5px #ccc;
        width: 32%;
        cursor: pointer;

        .service-box {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          width: 100%;

          .service-item {
            width: 100%;
            box-sizing: border-box;
            p {
              font-size: 16px;
              margin-bottom: 0;
              // 文字过长时，隐藏多余部分
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              width: 100%;
            }
          }
        }

        &:hover {
          background-color: #1890ff;
          color: #fff;
        }
      }

      .tag-card-active {
        background-color: #1890ff;
        color: #fff;
      }
    }
  }

  .level2-tagbox {
    // margin-left: 20px;
  }
}
</style>
